// frontend/src/components/ImpersonationBanner.js
import React from 'react';
import { Button } from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import { useAuth } from '../context/AuthContext';

const ImpersonationBanner = () => {
    const { impersonation, user, exitImpersonation } = useAuth();

    if (!impersonation) return null;

    return (
        <div
            style={{
                background: '#fa8c16',
                color: '#fff',
                padding: '8px 16px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 12,
                fontSize: 13,
                fontWeight: 500,
                position: 'sticky',
                top: 0,
                zIndex: 1000
            }}
        >
            <SwapOutlined />
            <span>
                Viewing as <strong>{user?.username}</strong> &mdash; impersonating (started by {impersonation.adminUsername})
            </span>
            <Button size="small" onClick={exitImpersonation}>
                Exit Impersonation
            </Button>
        </div>
    );
};

export default ImpersonationBanner;
